<!-- eslint-disable max-len -->
<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onSubmit"
  >
    <v-text-field
      v-model="form.name"
      :rules="rules.name"
      type="text"
      label="Название элемента"
    />
    <v-select
      v-if="OBJECT_TYPES_LIST"
      v-model="form.objectType"
      :items="OBJECT_TYPES_LIST"
      :disabled="isEdit || !!lockObjectType"
      item-value="id"
      item-text="title"
      label="Тип элемента"
    />
    <v-select
      v-if="mapTypes"
      v-model="form.mapType"
      :items="mapTypes"
      :disabled="isEdit"
      item-value="id"
      item-text="title"
      label="Вид элемента"
    />

    <custom-select
      :list="selectableCategoryList"
      :data="form.categoryId"
      :disabled="!!lockCategory || data.hasParent"
      label="Категория элемента"
      search
      search-label="Поиск категории"
      @search="debouncedCategorySearch"
      @change="changedIdInForm($event, 'categoryId')"
    />

    <custom-select
      v-if="['point', 'polygon', 'linestring'].includes(form.mapType)"
      :list="objectFormList || [objectFormSingle]"
      :data="form.formId"
      :disabled="Boolean(data.geometriesCount)"
      label="Форма, описывающая поля объектов"
      search
      search-label="Поиск формы"
      @search="debouncedFormSearch"
      @change="changedIdInForm($event, 'formId')"
    />

    <additional-regions-select
      v-model="form.availableRegions"
      label="Доступные регионы (отсутствие регионов = пользователю доступны все геометрии)"
      :data="data.availableRegions"
      :items-list="filteredRegionList"
      :excluded-list="[]"
      @search="onRegionSearch"
    />

    <v-checkbox
      v-if="!isEdit"
      v-model="form.authorizedOnly"
      :data="data.authorizedOnly"
      label="Только для авторизованных пользователей"
    />
    <rich-editor v-model="form.description" label="Описание элемента" />
    <!-- Верхняя часть работает при создании -->
    <!-- нижняя при редактировании -->
    <template v-if="isEdit">
      <IconSelectComponent
        v-if="!['orthophotomap', 'model', 'history'].includes(form.mapType)"
        v-model="form.iconId"
        :data="data.icon"
        :list="iconList"
        use-local-filter
        label="Иконка элемента"
        search
        search-label="Поиск иконок"
      />

      <custom-select
        v-if="form.objectType === 'event'"
        :list="computedLayerGroupsList"
        :data="data.group ? data.group.id : null"
        label="Группа"
        search
        search-label="Поиск групп"
        @search="debouncedGroupSearch"
        @change="changedIdInForm($event, 'groupId')"
      />
      <v-row>
        <v-col md="6" class="pt-0">
          <v-menu
            ref="menu1"
            v-model="dateMenuState"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateValue"
                label="Дата события"
                persistent-hint
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dateValue"
              locale="ru"
              no-title
              :first-day-of-week="1"
              @input="dateMenuState = false"
            />
          </v-menu>
        </v-col>

        <v-col md="6" class="pt-0">
          <v-menu
            ref="menu"
            v-model="timeMenuState"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="timeValue"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="timeValue"
                label="Время события"
                prepend-icon="access_time"
                readonly
                v-on="on"
              />
            </template>
            <v-time-picker
              v-if="timeMenuState"
              v-model="timeValue"
              format="24hr"
              full-width
              @click:minute="$refs.menu.save(timeValue)"
            />
          </v-menu>
        </v-col>
      </v-row>

      <v-card class="" elevation="0">
        <v-card-title>
          Отображение ресурса в карточке элемента
        </v-card-title>
        <v-card-subtitle>
          Отображение дополнительной информации об источнике,
          который предоставляет информацию по данному слою.
          Укажите кем предоставлены данные.
          <br>
          Вы можете использовать переменные поле формы, чтобы указать нужное значение в вашей ссылке ${Наименование} - и ваша ссылка приметь значение из конкретной точки.
          Пример: 'Наименование': 'Якутск', вы записываете ссылку вида https://example.ru?name=${Наименование}, в аталсе она трансформируется в https://example.ru?name=Якутск
          <br>
          Так же вы можете использовать переменные: ${geometryId}, ${externalId}
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
            v-model="form.dataProviderInfo.title"
            type="text"
            label="Название организация или компании"
          />

          <v-text-field
            v-for="index in dynamicSourceArray"
            :key="`sourceLinks-${index}`"
            :value="sourceValue(index)"
            :append-icon="setLinksIcon(index)"
            type="link"
            label="Ссылка на организацию или дополнительную информацию"
            placeholder="https://example.ru"
            @click:append="deleteLink(index - 1)"
            @input="handlerSourceLinks($event, index - 1)"
          />
          <IconSelectComponent
            v-model="form.dataProviderInfo.icon"
            :data="(form.dataProviderInfo && form.dataProviderInfo.icon) || null"
            :list="iconList"
            label="Иконка организации"
            search
            use-local-filter
            search-label="Поиск иконок"
          />
        </v-card-text>
      </v-card>

      <v-checkbox
        v-model="form.published"
        :disabled="isHistory"
        :persistent-hint="isHistory"
        hint="Управления статусом публикации осуществляется исключительно из родительского события"
        label="Элемент опубликован"
      />

      <v-checkbox
        v-if="data.mapType !== 'custom'"
        v-model="form.hasExternalConnection"
        label="Использовать данные стороних источников"
      />

      <v-checkbox
        v-model="form.authorizedOnly"
        :disabled="form.roleDependent"
        label="Только для авторизованных пользователей"
      />

      <v-checkbox
        v-model="form.roleDependent"
        label="Доступ к слою согласно настройкам прав доступа"
      />

      <template v-if="isSyncAvailable">
        <v-checkbox
          v-model="form.sync.isSyncEnable"
          messages="Данные слоя будут автоматически отправляться в публичную часть при каждом изменении раз в 4 часа."
          label="Автоматическая синхронизация слоя"
        />
        <div class="d-flex flex-column align-start">
          <v-btn
            color="warning"
            class="elevation-0 mt-4"
            title="Синхронизировать слой"
            @click="openConfirmationDialog"
          >
            Синхронизировать слой
            <v-icon class="ml-2">sync</v-icon>
          </v-btn>
          <v-btn
            color="warning"
            class="elevation-0 mt-4"
            title="Синхронизировать слой"
            @click="handleExport"
          >
            Экспортировать слой
          </v-btn>
        </div>
      <!-- <p v-show="form.sync.hasSyncInProgress">
        Слой находится в процессе синхронизации
      </p>
      <Progress
        v-if="form.sync.hasSyncInProgress"
        :value="form.sync.statusEvent.percent"
      /> -->
      </template>
    </template>

    <div class="d-flex justify-end">
      <v-btn v-if="!isEdit" type="submit" color="success" dark>Создать слой</v-btn>
      <v-btn v-else type="submit" color="primary" dark>Сохранить изменения</v-btn>
    </div>

    <confirmation-dialog
      name="sync-confirmation-dialog"
      :dialog="true"
      @confirmed="handleConfirmed()"
      @canceled="handleCanceled"
    >
      <template v-slot:title>
        Вы уверены?
      </template>

      <template v-slot:text>
        Синхронизировать слой "{{ data.name }}"
      </template>
    </confirmation-dialog>
  </v-form>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import IconSelectComponent from '@/components/ui/icon-select';
import RichEditor from '@/components/ui/rich-editor';
import CustomSelect from '@/components/ui/custom-select';
import ConfirmationDialog from '@/components/dialogs/confirmations/ConfirmationDialog.vue';
// import Progress from '@/components/common/Progress.vue';
import {
  MAP_TYPES,
  MAP_TYPES_FOR_SELECT,
  OBJECT_TYPES,
  OBJECT_TYPES_FOR_SELECT,
} from '@/utils/object-types';
import { loadRegions } from '@/utils/local-storage';
import moment from 'moment';
import AdditionalRegionsSelect from '@/views/users/components/UserForm/AdditionalRegionsSelect.vue';
import isClosedHost from '@/utils/is-closed-host';

// Половина элементов тут не нужна. layerForm должна передавать
// в родительский компонент изменения, а не создавать форму самостоятельно
const createDefaultForm = () => ({
  name: null,
  mapType: Object.keys(MAP_TYPES)[0],
  objectType: Object.keys(OBJECT_TYPES)[0],
  categoryId: null,
  description: null,
  templateDescription: null,
  icon: null,
  iconId: null,
  formId: null,
  groupId: null,
  authorizedOnly: true,
  roleDependent: false,
  hasExternalConnection: false,
  availableRegions: null,
  dataProviderInfo: {
    links: [],
    icon: null,
    title: null,
  },
});

const createDefaultRules = () => ({
  name: [
    v => !!v || 'Название слоя обязательно для заполнения',
  ],
  categoryId: [
    v => !!v || 'Не выбрана категория',
  ],
});

export default {
  name: 'layer-form',

  components: {
    CustomSelect,
    AdditionalRegionsSelect,
    IconSelectComponent,
    RichEditor,
    ConfirmationDialog,
  },

  props: {
    lockObjectType: String,
    lockCategory: String,
    except: {
      type: Array,
      default: () => ([]),
    },
    data: {
      type: Object,
      default: createDefaultForm,
    },
    isLoading: Boolean,
    isEdit: Boolean,
    isSmall: Boolean,
    categoryList: {
      type: Array,
      default: () => ([]),
    },
    iconList: {
      type: Array,
      default: () => ([]),
    },
  },

  data: () => ({
    formWithoutChange: {},
    form: createDefaultForm(),
    rules: createDefaultRules(),
    valid: true,
    dataFetching: false,
    formScrollPage: 1,
    dateValue: null,
    timeValue: null,
    dateMenuState: false,
    timeMenuState: false,
    isHistory: false,
    categoryQuery: '',
    regionsList: [],
    regionSearch: '',
  }),

  computed: {
    ...mapGetters(['permissions']),

    dynamicSourceArray() {
      return (this.form.dataProviderInfo.links
      && this.form.dataProviderInfo.links.length) + 1 || 1;
    },

    hasPermission() {
      return (perm) => this.permissions.includes(perm);
    },

    selectableCategoryList() {
      return (this.categoryList || [])
        .flatMap((c) => {
          const result = { id: c.id, name: c.name };
          if (c.id === this.form.categoryId) return result;

          return new RegExp(this.categoryQuery, 'i').test(c.name) ? result : [];
        });
    },

    submitIsAvailable() {
      return this.form.name && this.form.categoryId && this.form.type;
    },

    computedLayerGroupsList() {
      return !this.layerGroupsList ? [] : this.layerGroupsList.map(group => ({
        ...group,
        name: `${group.name} (${moment(group.happenedAt).format('DD.MM.YYYY')})`,
      }));
    },

    ...mapState('objectForms', {
      objectFormList: 'fullList',
      objectFormSingle: 'single',
      objectFormPagination: 'pagination',
    }),

    ...mapState('layerGroups', {
      layerGroupsList: 'fullList',
    }),

    ...mapState('system', ['isRegionFullListLoaded']),

    mapTypes() {
      const mapTypes = {};
      Object.keys(MAP_TYPES_FOR_SELECT).forEach(k => {
        mapTypes[k] = MAP_TYPES_FOR_SELECT[k].filter(_ => !this.except.includes(_.id));
      });
      return mapTypes[this.form.objectType];
    },

    isSyncAvailable() {
      return this.data?.sync?.isSyncAvailable && isClosedHost() && this.hasPermission('layerSynchronization');
    },

    filteredRegionList() {
      if (!this.regionSearch) {
        return this.regionsList;
      }
      const regex = new RegExp(this.regionSearch, 'i');

      return this.regionsList.filter((r) => regex.test(r.name));
    },
  },

  watch: {
    dateValue: 'updateHappenedAt',
    timeValue: 'updateHappenedAt',

    isRegionFullListLoaded(state) {
      if (state) this.regionsList = loadRegions();
    },
  },

  async created() {
    this.saveDataPropsIntoForm(this.data);
    this.MAP_TYPES_LIST = MAP_TYPES_FOR_SELECT;
    this.OBJECT_TYPES_LIST = OBJECT_TYPES_FOR_SELECT;
    if (this.isRegionFullListLoaded) this.regionsList = loadRegions();

    if (this.lockObjectType) this.form.objectType = this.lockObjectType;
    if (this.lockCategory && this.lockCategory !== 'locked') this.form.categoryId = this.lockCategory;

    this.debouncedCategorySearch = debounce(this.onCategorySearch, 500);
    this.debouncedFormSearch = debounce(this.onFormSearch, 1000);
    this.debouncedGroupSearch = debounce(this.onGroupSearch, 1000);
  },
  mounted() {
    this.formWithoutChange = Object.assign({}, this.form);
    this.$emit('registerGuard', [this.formWithoutChange, this.beforeLeave]);
    // console.log(this.data);
    // const { statusEvent } = this.data.sync;
    // console.log(statusEvent);
    // if (statusEvent) {
    //   this.$echo.channel(`.object-sync.${statusEvent.layerObjectSyncId}`)
    //     .listen('.LayerObjectSyncStatus', (data) => {
    //       console.log(data);
    //     });
    // }
  },
  beforeDestroy() {
    //
    // this.$echo.leave(`.object-sync.${this.data.id}`);
  },
  methods: {
    beforeLeave() {
      return this.form;
    },
    sourceValue(index) {
      return this.form.dataProviderInfo && this.form.dataProviderInfo.links ? this.form.dataProviderInfo.links[index - 1] : '';
    },
    setLinksIcon(index) {
      return index > (this.form.dataProviderInfo && this.form.dataProviderInfo.links && this.form.dataProviderInfo.links.length) || 0 ? null : 'delete';
    },
    deleteLink(index) {
      this.form.dataProviderInfo.links.splice(index, 1);
    },

    handlerSourceLinks(event, index) {
      if (!this.form.dataProviderInfo.links) {
        Vue.set(this.form.dataProviderInfo, 'links', [event]);
      } else {
        Vue.set(this.form.dataProviderInfo.links, index, event);
      }
    },

    saveDataPropsIntoForm(value) {
      this.form = {
        ...this.form,
        ...value,
        categoryId: get(value, 'category.id', null),
        iconId: get(value, 'icon.id', null),
        availableRegions: (value.availableRegions || []).map(element => element.id),
      };

      if (!this.form.dataProviderInfo) {
        this.form.dataProviderInfo = {
          links: [],
          icon: null,
          title: null,
        };
      }

      this.isHistory = this.isEdit && this.form.hasParent;

      if (value.happenedAt) {
        const date = moment(value.happenedAt, ['YYYY-MM-DD HH:mm:ss']);
        this.dateValue = date.format('YYYY-MM-DD');
        this.timeValue = date.format('HH:mm');
      }
    },
    ...mapActions('objectForms', {
      objectFormGetList: 'getFullList',
    }),

    ...mapActions('layerGroups', {
      layerGroupGetList: 'getFullList',
    }),

    onSubmit() {
      // Тут просто тотальный прикол
      // Каждое изменение формы все равно улетает в родительский компонент через emit.
      // Но сохраняется зачем-то отдельно уже через this.form
      // Ошибка нужно очищать форму от значений null
      // Тогда база не будет засорена и это успростит проверку на фронте
      // данная проверка добалена, так как иконки организаций могут удалить
      if (this.iconList) {
        const hasIcon = this.iconList.some(icon => icon.id === this.form.dataProviderInfo.icon);
        if (this.form.dataProviderInfo.icon && !hasIcon) {
          this.form.dataProviderInfo.icon = null;
        }
      }
      if (this.$refs.form.validate()) {
        this.valuesWithoutChange = Object.assign({}, this.form);
        this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
        this.$emit('submit', this.form);
      }
    },

    handleExport() {
      this.$emit('export', this.form.id);
    },

    async onFormSearch(query) {
      await this.objectFormGetList({ query });
    },

    onCategorySearch(query) {
      this.categoryQuery = query;
    },
    changedIdInForm(id, prop) {
      // TODO А при каких условиях у нас тут вообще может быть объект?
      if (typeof id === 'object') return;
      this.form[prop] = id;
    },

    async onGroupSearch(query) {
      await this.layerGroupGetList({ query });
    },

    updateHappenedAt() {
      if (this.dateValue && this.timeValue) {
        this.form.happenedAt = moment(`${this.dateValue}T${this.timeValue}+0000`);
      }
    },

    onRegionSearch(search) {
      this.regionSearch = search;
    },

    openConfirmationDialog() {
      this.$dialog.show('sync-confirmation-dialog');
    },

    handleConfirmed() {
      this.$emit('syncLayer', this.form.id);
      this.$dialog.hide('sync-confirmation-dialog');
    },

    handleCanceled() {
      this.$dialog.hide('sync-confirmation-dialog');
    },
  },
};
</script>
